import React from 'react';
import styled, { keyframes } from 'styled-components';

const faders = [
  keyframes`
    0% { opacity: 0; }
    50% { opacity: 1; }
    100% { opacity: 0; }
  `,
  keyframes`
    0% { opacity: 0.5; }
    50% { opacity: 0; }
    100% { opacity: 0.5; }
  `,
  keyframes`
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
  `,
];

const Element = styled.img`
  position: fixed;
  top: ${props => props.top};
  left: ${props => props.left};
  width: 8px;
  height: 8px;

  will-change: transform;
  animation: ${props => faders[props.animation]} 10s ease-in-out infinite;
`;

const XOs = [];
const XO_COUNT = 100;

for (var i = 0; i <= XO_COUNT; i++) {

  let content = (i % 2 === 0 ? 'x' : 'o');
  let top = Math.floor(Math.random() * 100) + '%';
  let left = Math.floor(Math.random() * 100) + '%';
  let src = `/images/${content}.svg`;
  let animation = Math.floor(Math.random() * 3);

  XOs.push(
    <Element top={top} left={left} key={i} src={src} animation={animation} />
  );

}

const XO = () => (
  <div>
    {XOs}
  </div>
);

export default XO;



// WEBPACK FOOTER //
// ./src/components/ui/XO.js